import React, { Component } from 'react';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './login.css';
import * as util from './util.js';
import loginIcon from './resource/Icon_LOGIN_fmt.png';
import company from './resource/company.png';
import doctor from './resource/doctor.png';
import privateMan from './resource/private.png';
import configObject from './variables.js';


let faqLogin = [
];

export class Login extends Component {
  constructor (props) {
    super(props);
    this.handleUsername = this.handleUsername.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.login = this.login.bind(this);
    this.state = {username: '',
                  password: ''
    }
  }

  componentDidMount () {
    if ('username' in this.props.match.params)
      this.setState({username: this.props.match.params.username});
    if ('password' in this.props.match.params)
      this.setState({password: this.props.match.params.password});
  }

  handleUsername(event) {
    this.setState({username: event.target.value.trim()});
  }

  handlePassword(event) {
    this.setState({password: event.target.value});
  }

  handleSubmit(event) {
    var login = this.login(this.state.username, this.state.password);
    var self = this;
    login.then( function(json) {
      if (json.loggedIn === true) {
        self.props.propagateLogin(true, json.username, json.role, json.token);
        self.props.history.replace('/');
      } else {
        self.props.propagateLogin(true, 'guest', 'guest', configObject.guestJWT);
        alert('LOGIN fehlgeschlagen.');
      };
     if (json.temporaryPassword === true) {
       alert('Ihr Passwort ist temporär, bitte ändern Sie es.');
       window.location.href = `profile/${self.state.password}#content2`;
     }
    }).catch( () => { self.props.propagateLogin(true, 'guest', 'guest', configObject.guestJWT);
      alert('LOGIN fehlgeschlagen.')
    });
    return true;
  }

  login(username, password) {
    const url='/api/login';
    var promise = fetch(url, {method: 'POST',
                              headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                              },
                              body:`username=${username}&password=${password}`,
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error('Login failed? Is the server running?', exception);
      })
    return promise;
  }

  render() {
    return (
      <div className="Landing" id="contentId">
      <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
      { this.props.username === 'guest' &&
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="contentHeaderText">
              Login
            </div>
            <div className="loginTileDown marginTop30">

              <div className="loginTileDownOneTile backgroundTransparent ">
                <input autoFocus="autofocus" placeholder="Name/Mailadresse" className="loginInput margin-right" type="text"
                       onKeyUp={ event => event.key === 'Enter' ? this.handleSubmit() : true} onChange={this.handleUsername} value={this.state.username}></input>
                <div className="buttonDiv LoginButtonDesktop">
                  <div className="button" onClick={this.handleSubmit}>Login<img className="buttonIcon" src={loginIcon} alt="logo" /> </div>
                </div>
              </div>
              <div className="loginTileDownOneTile backgroundTransparent ">
                <input placeholder="Passwort" className="loginInput" type="password"
                       onKeyUp={ event => event.key === 'Enter' ? this.handleSubmit() : true} onChange={this.handlePassword} value={this.state.password}></input>
                <div className="buttonDiv LoginButtonMobil">
                  <div className="button" onClick={this.handleSubmit}>Login<img className="buttonIcon" src={loginIcon} alt="logo" /> </div>
                </div>
                <div className="buttonDiv">
                  <div className="button" onClick={event => this.props.history.push({ pathname: "/forgot-password", state: { username: this.state.username }})}>
                    Passwort vergessen?
                  </div>
                </div>
              </div>
            </div>

            <div className="contentHeaderText marginTop50">
              Registrierung
            </div>
            <div className="loginTileDown marginTop30 pointer justifyContentBetween">
              <div className="loginTileDownOneTileSmall center" onClick={event => this.props.history.push("/registration/non_commercial")}>
                <div className="margin10">
                  <div>
                    <img src={privateMan} alt="private" />
                  </div>
                  <div className="contentText FontMedium">
                    als Privatperson <br/>
                  </div>
                </div>
              </div>
              <div className="loginTileDownOneTileSmall center pointer" onClick={event => this.props.history.push("/registration/non_commercial")}>
                <div className="margin10">
                  <div>
                    <img src={doctor} alt="gesundheistwesen" />
                  </div>
                  <div className="contentText FontMedium">
                    als Mitarbeitende im Gesundheitswesen <br/>
                  </div>
                </div>
              </div>
              <div className="loginTileDownOneTileSmall center pointer" onClick={event => this.props.history.push("/registration/commercial")}>
                <div className="margin10">
                  <div>
                    <img src={company} alt="hersteller" />
                  </div>
                  <div className="contentText FontMedium">
                    als Herstellende <br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {util.isCommercialUser() || ( util.isNonCommercialUser() &&
        <div className="Landing" id="contentId">
           <div className="ContentWithBackground">
           <div className="content" id="content">
               <div className="productHeader1">Sie sind bereits eingeloggt</div>
           </div>
           </div>
        </div>)
         }
      <Footer faqs={faqLogin} />
      </div>
    );
  }
}

export class ForgotPassword extends Component {

  constructor (props) {
    super(props);
    this.state = { username: this.props.location.state.username };
  }

  handleUsername = event => {
    this.setState( {username: event.target.value.trim()} );
  }

  resendPassword = event => {
    event.preventDefault();
    const url = '/api/reset-password';
    if(window.confirm(`Wirklich das Passwort für '${this.state.username}' zurücksetzen?`)) {
      fetch(url, {
        method: 'POST',
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:`username=${this.state.username}`
      })
        .then(util.handleErrors)
        .then(response => response.json())
        .then(json => alert('Eine Email mit dem neuen Passwort wurde Ihnen zugeschickt.'))
        .then( () => this.props.history.push('/login') )
        .catch(function(exception) {
          alert('Benutzerkonto nicht gefunden. Benutzen Sie Ihren Nutzernamen oder Ihre Emailadresse.');
        })
    }
  }

  render() {
    return (<div className="Landing" id="contentId">
            <Header />
            <div className="ContentWithBackgroundShort">

              <div className="content">
              <div className="loginTileDownOneTile backgroundTransparent horizontallyCenter">
                <input autoFocus="autofocus" placeholder="Name/Mailadresse" className="loginInput" type="text"
                       value={this.state.username} onChange={this.handleUsername}>
                </input>
                <div className="buttonDiv LoginButtonDesktop">
                  <div className="button" onClick={this.resendPassword}>Passwort Zurücksetzen<img className="buttonIcon" src={loginIcon} alt="logo" /></div>
                </div>
              </div>
              </div>

            </div>
            <Footer faqs={faqLogin} />
            </div>);
  }

}



// WEBPACK FOOTER //
// ./src/login.js